import React from 'react';

export interface IGaugeBarTicks {
  numberOfTicks: number;
  tickerHight: number;
  zeroPositionAsPrec: string;
}
export const GaugeBarTicks: React.FC<IGaugeBarTicks> = ({ numberOfTicks, tickerHight, zeroPositionAsPrec }) => {
  return (
    <div className={`w-full  mt-[0rem]   flex`} style={{ minHeight: `${tickerHight}rem` }}>
      {Array.from({ length: numberOfTicks }).map((_, index) => (
        <div
          key={index}
          className={`w-[8%] border-l border-l-secondary`}
          style={{ width: `${100 / numberOfTicks}%` }}
        ></div>
      ))}
      <div className="border-l border-l-secondary"></div>
      <div style={{ left: `${zeroPositionAsPrec}%` }} className={`absolute h-full z-5 flex flex-col  `}>
        <div className="ml-[-0.3rem] mt-[0.5rem]">0</div>
      </div>
    </div>
  );
};
